<template>
  <div class="payment-library">
    <library-list v-if="settlements.length > 0" :data-library="settlements" :library-list-receive="settlements"/>
    <template v-else>
      <div class="library-empty">
        <div class="library-empty__contents">
          <img src="/static/img/icons/uranaitv_logo_lite.svg" class="library-empty__image" alt=""><br>
          購入した商品がありません
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LibraryList from './PaymentLibraryList'

export default {
  name: 'PaymentLibrary',
  components: {
    LibraryList
  },
  props: {
    settlements: {
      type: Array,
      default () {
        return []
      }
    }
  }
}</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.payment-library {}
.library-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 20px;
  left: 0;
  right: 0;
  z-index: 1;
  &__contents {
    color: $col_temp_gray5;
    font-size: 13px;
    text-align: center;
  }
  &__image {}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/PaymentLibrary.vue